import { apiCall } from "../../services/api-service";

export const getTripCostListApi = async (params) => {
  try {
    const response = await apiCall("GET", "tripcost", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitTripCostAPI = async (body) => {
  try {
    const response = await apiCall("POST", "tripcost", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateTripCostAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `tripcost/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripCostEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `tripcost/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteTripsApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `tripcost/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteTripsApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await apiCall("DELETE", "tripcost/bulkdelete", data);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripCostViewApi = async (id) => {
  try {
    const response = await apiCall("GET", `tripcost/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getActualWorkflowApi = async (id) => {
  try {
    const response = await apiCall("GET", `trips/workflow/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEstimateWorkflowApi = async (id) => {
  try {
    const response = await apiCall("GET", `stop/est_workflow/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTripDetailApi = async (id) => {
  try {
    const response = await apiCall("GET", `tripcost/trip/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `tripcost/attachment/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
